import AddRemarkAction from "@/Components/PosMenuAction/AddRemarkAction";
import AddToppingAction from "@/Components/PosMenuAction/AddToppingAction";
import ChangeProductPriceAction from "@/Components/PosMenuAction/ChangeProductPriceAction";
import ClientModalAction from "@/Components/PosMenuAction/ClientModalAction";
import CustomProductAction from "@/Components/PosMenuAction/CustomProductAction";
import CustomerOrderHistoryAction from "@/Components/PosMenuAction/CustomerOrderHistoryAction";
import CustomerPaysWithAction from "@/Components/PosMenuAction/CustomerPaysWithAction";
import DeliveryCostAction from "@/Components/PosMenuAction/DeliveryCostAction";
import EmptyTheCartAction from "@/Components/PosMenuAction/EmptyTheCartAction";
import EnterTableNumberAction from "@/Components/PosMenuAction/EnterTableNumberAction";
import OpenCashDrawerAction from "@/Components/PosMenuAction/OpenCashDrawerAction";
import OpenCustomerScreenAction from "@/Components/PosMenuAction/OpenCustomerScreenAction";
import PosOrderDiscountAction from "@/Components/PosMenuAction/PosOrderDiscountAction";
import PosOrderDiscountCodeAction from "@/Components/PosMenuAction/PosOrderDiscountCodeAction";
import PosSettingsAction from "@/Components/PosMenuAction/PosSettingsAction";
import PrintReceiptAction from "@/Components/PosMenuAction/PrintReceiptAction";
import ScanBarcodeAction from "@/Components/PosMenuAction/ScanBarcodeAction";
import NewOrderAction from "@/Components/PosMenuAction/NewOrderAction";
/* TODO: will add next release*/
/* import ServiceCostAction from "@/Components/PosMenuAction/ServiceCostAction"; */
import TipAction from "@/Components/PosMenuAction/TipAction";
import useElectronHook from "@/shared/hooks/useElectronHook";

const usePosMenuBottomActionsHook = () => {
  const { isElectron } = useElectronHook();

  const primaryActions: React.ReactNode[] = [
    // <CustomProductAction  />,
    <NewOrderAction />,
    <ClientModalAction />,
  ];

  const topActions: React.ReactNode[] = [
    <ChangeProductPriceAction />,
    <AddToppingAction />,
    <CustomerPaysWithAction />,
    <DeliveryCostAction />,
    <PrintReceiptAction />,
    <PosOrderDiscountCodeAction />,
    <PosSettingsAction />,
    <OpenCashDrawerAction />,
  ].slice(0, isElectron ? 8 : 7);

  const bottomActions: React.ReactNode[] = [
    <EnterTableNumberAction />,
    <PosOrderDiscountAction />,
    // <EmptyTheCartAction />,
    <CustomProductAction />,
    <AddRemarkAction />,
    <CustomerOrderHistoryAction />,
    <ScanBarcodeAction />,
    <TipAction />,
    <OpenCustomerScreenAction />,
  ].slice(0, isElectron ? 8 : 7);

  return {
    primaryActions,
    topActions,
    bottomActions,
  };
};

export default usePosMenuBottomActionsHook;
